const getUser = async () => {
  try {
    const response = await fetch(
      process.env.NODE_ENV === "production"
        ? `/ignitionapi/ProductService/ProductUser`
        : `http://local.legrandav.com/ignitionapi/ignitionapi/ProductService/ProductUser`,
    );

    const data = await response.json();

    return data;
  } catch (error) {
    console.log(`getProduct error: ${error}`);
  }
};

export default getUser;
